export const FETCH_INSTRUMENTS_REQUEST = "FETCH_INSTRUMENTS_REQUEST";
export const FETCH_INSTRUMENTS_SUCCESS = "FETCH_INSTRUMENTS_SUCCESS";
export const FETCH_INSTRUMENTS_FAILURE = "FETCH_INSTRUMENTS_FAILURE";
